import { ControlledInput } from "@/components/controlled-input"
import { filterInvalidUsernameCharacters } from "@/lib/validations/filter-invalid-username-characters"
import { ChangeEventHandler } from "react"
import { useController, UseControllerProps } from "react-hook-form"
import { LoginFormValues } from "./login-form"

export const USERNAME_REQUIRED_ERROR = "Errors.usernameRequiredError"

type LoginFormUsernameInputProps = UseControllerProps<LoginFormValues> & {
  onChange?: ChangeEventHandler<HTMLInputElement>
}

export function LoginFormUsernameInput({
  name,
  control,
  onChange,
}: LoginFormUsernameInputProps) {
  const { field } = useController({ name, control })

  const handleChange: ChangeEventHandler<HTMLInputElement> = (event) => {
    filterInvalidUsernameCharacters(field).onChange(event)
    onChange?.(event)
  }

  const isSnai = window.APP_VENDOR === "snai"

  return (
    <ControlledInput
      className={isSnai ? "autofill-btn-text" : ""}
      label="LoginPage.LoginForm.usernameFieldLabel"
      name={name}
      data-qa="login-form-username-input"
      autoComplete="on"
      maxLength={50}
      controlValue={filterInvalidUsernameCharacters}
      onChange={handleChange} // This overrides the controlValue onChange handler
    />
  )
}
